module.exports = __webpack_public_path__ + "media/images/cc_expired_icon-64a579fed58d2994ad8422caaea5d0c8.svg";